<!-- MIGRATION: [maskInput]="'00/00/0000'"-->
<div class="input-control-wp">
  <input
    #input
    matInput
    *ngIf="newDateFormat"
    [matDatepicker]="picker"
    [class.invalid]="!isValid()"
    [ngClass]="{ 'input-error': hasError }"
    [type]="inputType"
    (dateChange)="addEventChange($event)"
    [value]="value"
    [min]="minDate"
    [max]="maxDate"
    (input)="onInput($event)"
    [placeholder]="placeholder"
    [attr.aria-labelledby]="ariaLabelledBy || null"
    [disabled]="isDisabled"
    [readOnly]="edit"
    (blur)="onTouched($event)"
    (keypress)="keyPressNumbers($event)"
    (focus)="onFocus()"
  />

  <input
    #input
    euDateFormat
    matInput
    *ngIf="isEuDatetimeFormat && !newDateFormat"
    [matDatepicker]="picker"
    [class.invalid]="!isValid()"
    [ngClass]="{ 'input-error': hasError }"
    [type]="inputType"
    (dateChange)="addEventChange($event)"
    [value]="value"
    [min]="minDate"
    [max]="maxDate"
    (input)="onInput($event)"
    [placeholder]="placeholder"
    [attr.aria-labelledby]="ariaLabelledBy || null"
    [disabled]="isDisabled"
    [readOnly]="edit"
    (blur)="onTouched($event)"
    (keypress)="keyPressNumbers($event)"
    (focus)="onFocus()"
  />

  <input
    #input
    amDateFormat
    matInput
    *ngIf="!isEuDatetimeFormat && !newDateFormat"
    [matDatepicker]="picker"
    [class.invalid]="!isValid()"
    [ngClass]="{ 'input-error': hasError }"
    [type]="inputType"
    (dateChange)="addEventChange($event)"
    [value]="value"
    [min]="minDate"
    [max]="maxDate"
    (input)="onInput($event)"
    [placeholder]="placeholder"
    [attr.aria-labelledby]="ariaLabelledBy || null"
    [disabled]="isDisabled"
    [readOnly]="edit"
    (blur)="onTouched($event)"
    (focus)="onFocus()"
  />

  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker [startView]="startView" [startAt]="startDate" #picker></mat-datepicker>
</div>
